import React, { useState, useEffect } from "react";
import { keyframes } from "@emotion/react";
import { styled } from "@mui/material/styles";

const StyledSvg = styled("svg")({
  position: "relative",
});

const RotatingRect = styled("rect")(({ active }) => ({
  fill: active ? "var(--Secondary-500, #AC5CCC)" : "#E2E6E9",
  transition: "fill 0.3s ease-in-out",
}));

const positions = [
  { x: "22.5", y: "0" },
  { x: "34.3994", y: "16.9288", transform: "rotate(-135 34.3994 16.9288)" },
  { x: "36.5", y: "26", transform: "rotate(-90 36.5 26)" },
  { x: "31.5713", y: "33.8995", transform: "rotate(-45 31.5713 33.8995)" },
  { x: "22.5", y: "36" },
  { x: "8.94336", y: "42.3848", transform: "rotate(-135 8.94336 42.3848)" },
  { x: "0.5", y: "26", transform: "rotate(-90 0.5 26)" },
  { x: "6.11523", y: "8.4436", transform: "rotate(-45 6.11523 8.4436)" },
];

const LoadingSpinner = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % positions.length);
    }, 300);
    return () => clearInterval(interval);
  }, []);

  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      {positions.map((pos, index) => (
        <RotatingRect key={index} {...pos} active={index === activeIndex} width="4" height="12" rx="2" />
      ))}
    </StyledSvg>
  );
};

export default LoadingSpinner;
